
<template>
  <div class="home">
    <!-- <SfHero class="boutique" :style="{ maxWidth: '1240px', margin: 'auto' }">
      <SfHeroItem :image="require('@/assets/img/boutique.png')" />
    </SfHero>-->
    <div class="boutique" :style="{backgroundImage:`url(${require('@/assets/img/boutique.png')})`}" />
    <div class="presentation">{{text}}</div>
  </div>
</template>

<script>
import { SfHero } from "@storefront-ui/vue";
export default {
  components: { SfHero },
  data() {
    return {
      text: `
En 1986 Fêt'Art ouvre ses portes rue Laurier puis une deuxième boutique ouvre sur l’avenue du Mont Royal. 
Depuis presque 35 ans, je choisis pour vous des vêtements confortables faits de matières naturelles et organiques. Étant artiste peintre de formation mon choix est axé exclusivement sur les couleurs, les textures ainsi que sur le confort offert par les matières naturelles. Je vous propose également de plus en plus de collections de tissus organiques tels que le lin et le coton. 
Être tout simplement bien dans ses vêtements, notre deuxième peau.

Nous offrons un choix parmi les collections de plusieurs grandes marques européennes, canadiennes et québécoises dont Esprit, Sandwich, Desigual, Nile, White Stuff, In Wear, Part Two, Kaffe, Cream, Parkhurst, Cotton Country, Simon Chang, Femme Fatale et Neon Buddha.
De plus nous vous proposons notre collection de bijoux exclusifs Fêt’art, les collections d’Anne-Marie Chagnon, de plusieurs designers québécois ainsi que notre choix de foulards colorés et enveloppants qui complètent le tout.

Nous recevons des nouveautés  chaque semaine, alors suivez-nous ici-même et n’hésitez pas à communiquer avec nous pour plus de détails.

- Michèle Anne Brosseau
`,
      textAndre: `
C’est depuis 1986 que je choisis pour vous des vêtements confortables, faits de matières naturelles et organiques. Artiste de formation, je privilégie les couleurs, les textures et le confort des matières naturelles, incluant des tissus organiques tels que le lin et le coton. Je vois les vêtements comme une deuxième peau.

Nos collections comptent plusieurs grandes marques: Esprit, Sandwich, Desigual, Nile, White Stuff, In Wear, Part Two, Kaffe, Cream, Parkhurst, Cotton Country, Simon Chang, Femme Fatale et Neon Buddha.

Ne pas manquez pas notre collection exclusive de bijoux Fêt’art, les collections d’Anne-Marie Chagnon et d’autres designers d’ici, le tout enveloppé d’un beau choix de foulards colorés.

Nous recevons des nouveautés chaque semaine: suivez-nous et n’hésitez pas à communiquer avec nous!

- Michèle Anne Brosseau
        `,
      text1: `
En 1986 Fêt'Art ouvre ses portes rue Laurier puis une deuxième boutique ouvre sur l’avenue du Mont Royal. 
Depuis presque 35 ans, je choisis pour vous des vêtements confortables faits de matières naturelles et organiques. 

Étant artiste peintre de formation mon choix est axé exclusivement sur les couleurs, les textures ainsi que sur le confort offert par les matières naturelles. Je vous propose également de plus en plus de collections de tissus organiques tels que le lin et le coton. Être tout simplement bien dans ses vêtements, notre deuxième peau.

Nous offrons un choix parmi les collections de plusieurs grandes marques européennes, canadiennes et québécoises dont Esprit, Sandwich, Desigual, Nile, White Stuff, In Wear, Part Two, Kaffe, Cream, Parkhurst, Cotton Country, Simon Chang, Femme Fatale et Neon Buddha.

De plus nous vous proposons notre collection de bijoux exclusifs Fêt’art, les collections d’Anne-Marie Chagnon, de plusieurs designers québécois ainsi que notre choix de foulards colorés et enveloppants qui complètent le tout.
Nous recevons des nouveautés chaque semaine, alors suivez-nous ici- même et n’hésitez pas de communiquer avec nous pour plus de détails.

- Michèle Anne Brosseau
`
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/vue/styles.scss";

.home {
  margin: -8px -8px -8px -8px;
}
.boutique {
  height: calc(100% - 220px);
  @media (min-width: 630px) {
    height: calc(100% - 180px);
  }
  width: 100%;
  background-size: cover;
  background-attachment: fixed;
  //   border-radius: 20px 20px 0 0;
  margin-top: 20px;
}

.presentation {
  background: #ca0074;
  color: white;
  text-align: justify;
  padding: 3rem 2rem 3rem 2rem;
  @media (min-width: 630px) {
    padding: 3rem 20% 3rem 20%;
  }
  white-space: pre-wrap;
}
</style>



